import { Slide01Title } from './Slide01Title'
import { Slide02Problem } from './Slide02Problem'
import { Slide03Persona } from './Slide03Persona'
import { Slide04Opportunity } from './Slide04Opportunity'
import { Slide05Hypothesis } from './Slide05Hypothesis'
import { Slide06Feature } from './Slide06Feature'
import { Slide07HowItWorks } from './Slide07HowItWorks'
import { Slide08Metrics } from './Slide08Metrics'
import { Slide06OpenQuestions } from './Slide06OpenQuestions'

export const slides = [
  Slide01Title,
  Slide02Problem,
  Slide03Persona,
  Slide04Opportunity,
  Slide05Hypothesis,
  Slide06Feature,
  Slide07HowItWorks,
  Slide08Metrics,
  Slide06OpenQuestions,
]
